// filter.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure: false // recalc when items/searchText change
    ,
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform<T extends Record<string, any>>(
    items: T[],
    searchText: string,
    prop?: keyof T
  ): T[] {
    if (!items) return [];
    if (!searchText) return items;

    const needle = searchText.toLowerCase();

    return items.filter(item => {
      if (prop) {
        return ((item[prop] ?? '') as string).toLowerCase().includes(needle);
      }
      // check all properties
      return Object.values(item).some(val =>
        val && val.toString().toLowerCase().includes(needle)
      );
    });
  }
}
